import { opaccLogPlugin, opaccAjaxPlugin } from '../opacc.static.js';
import { accountMessages, generalMessages } from '../messages/opacc.messages.js';

/** @module account */

/**
 * Funktionalität für den Bereich "Mein Account"
 *
 */
export class OpaccAccount {
	constructor() {
		this.deleteAddr = document.querySelectorAll('a.delete-list-item');
		this.filter = document.querySelectorAll('.list-filter');
		this.password = document.querySelectorAll('input[type="password"]');
		this.editMode = document.querySelectorAll('button[data-op-editmode]');
		this.editClass = 'is-changing';
		this.requestData = {};
		this.attachEventListener();
	}

	/**
	 *
	 *
	 */
	attachEventListener() {
		// Rueckfrage vor dem Loeschen einer Adresse
		if (this.deleteAddr) {
			Array.from(this.deleteAddr).forEach(link => {
				link.addEventListener('click', event => {
					event.preventDefault();
					opaccLogPlugin.showConfirm(accountMessages.messageDelete.text, generalMessages.messageOk.text, generalMessages.messageCancel.text, function() {
						window.location.href = link.href;
					});
				});
			});
		}
		// Bestellungen filtern nach Anzahl, Datum und Typ
		if (this.filter) {
			Array.from(this.filter).forEach(item => {
				let selectboxs = item.querySelectorAll('select');
				Array.from(selectboxs).forEach(select => {
					select.addEventListener('change', () => {
						this.sendAjaxRequest(item);
					});
				});
			});
		}
		// Passwort anzeigen
		if (this.password) {
			Array.from(this.password).forEach(field => {
				if (field.nextElementSibling) {
					if (field.nextElementSibling.firstElementChild) {
						if (field.nextElementSibling.firstElementChild.nodeName === 'BUTTON') {
							field.nextElementSibling.firstElementChild.addEventListener('mouseover', () => {
								field.type = 'text';
							});
							field.nextElementSibling.firstElementChild.addEventListener('mouseout', () => {
								field.type = 'password';
							});
						}
					}
				}
			});
		}
		// Edit-Mode aktivieren
		if (this.editMode) {
			Array.from(this.editMode).forEach(button => {
				button.addEventListener('click', event => {
					if (button.getAttribute('data-op-editmode') === 'column') {
						if (!button.closest('.opc-col').classList.contains(this.editClass)) {
							event.preventDefault();
							button.closest('.opc-col').classList.add(this.editClass);
						}
					}
					else if (button.getAttribute('data-op-editmode') === 'item') {
						if (!button.closest('.list-item').classList.contains(this.editClass)) {
							event.preventDefault();
							button.closest('.list-item').classList.add(this.editClass);
						}
					}
					else if (button.getAttribute('data-op-editmode') === 'new') {
						let firstItem = document.querySelector('.list-item');
						if (firstItem) {
							firstItem.classList.toggle(this.editClass);
						}
					}
				});
			});
		}
	}

	/**
	 *
	 *
	 * @param {*} currentFilter
	 */
	sendAjaxRequest(currentFilter) {
		let entries = currentFilter.querySelector('#field-entries');
		let period = currentFilter.querySelector('#field-period');
		let type = currentFilter.querySelector('#field-type');
		let datefrom = currentFilter.querySelector('#field-datefrom');
		let dateto = currentFilter.querySelector('#field-dateto');
		this.requestData = {
			entries: entries ? entries.value : '',
			period: period ? period.value : '',
			type: type ? type.value : '',
			datefrom: datefrom ? datefrom.value : '',
			dateto: dateto ? dateto.value : ''
		};
		opaccAjaxPlugin.fetchAsynPostForm(window.location.href, this.requestData, this.refreshContent.bind(this, currentFilter), this.getDefaultErrorFnc, true);
	}

	/**
	 *
	 *
	 * @param {*} currentFilter
	 * @param {*} response
	 */
	refreshContent(currentFilter, response) {
		if (response.success) {
			let contentContainer = currentFilter.nextElementSibling;
			if(contentContainer) {
				let sourceContainer = document.createElement('div');
				sourceContainer.innerHTML = response.dataAsHtml;
				let source = sourceContainer.getElementsByClassName(contentContainer.className);
				if(source.length > 0) {
					contentContainer.innerHTML = source[0].innerHTML;
				}
			}
		}
	}
}